import { onBeforeUnmount, onMounted, ref } from 'vue';

export function useScrolledPast(offset) {
  const scrolled = ref(false);
  const onScroll = () => {
    scrolled.value = window.scrollY > offset;
  };

  onMounted(() => {
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  });
  onBeforeUnmount(() => window.removeEventListener('scroll', onScroll));

  return scrolled;
}
